<template>
  <div class="pi-my-coupon-third">

    <div class="coupon-third-list">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
        <ul class="coupon-third-ul">
          <li class="coupon-third-item" v-for="(item, index) in couponList"
           :key="index">
            <div class="coupon-title">
              <!-- <div class="coupon-type">洗车券</div> -->
              {{item.couponTitle}}
            </div>
            <div class="info-text">
              领取时间：{{item.releaseTime}}
            </div>
            <div class="info-text" @click="getMyCouponInstructions(item)">
              使用说明：
              <div class="explain-icon" :class="{'open': item.isOpen}">
                <img src="../../assets/image/lower-icon-2.png" alt="">
              </div>
            </div>
            <!-- :class="{'text-hide-2':!item.isOpen}" -->
            <div class="explain " v-show="item.isOpen" >{{item.text}}</div>
            
          </li>
        </ul>
      </van-list>
    </div>
  </div>
</template>
<script>
import { getMyCoupon,getMyCouponInstructions } from "@/common/api";
import { List } from "vant";
export default {
  name: "pi-my-coupon-third",
  components: {
    [List.name]: List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      couponList: [
      ],
      form: {
        accounPkId: "",
        couponType: '5',
        couponStatus: "0",
        globalPageIndex: 0,
        globalPageSize: 10,
      },
    };
  },
  methods: {
    getMyCouponInstructions(item) {
      item.isOpen = !item.isOpen;
      
      if(item.isOpen && item.text == ''){
        getMyCouponInstructions({
        couponTemplatePkId: item.couponTemplatePkId
      })
        .then(response => {
          if (response.status == this.$config.ajaxStatus) {
            item.text = response.data[0] || '';
          }
        })
      }
      
    },
    onLoad() {
      this.form.globalPageIndex++;
      this.getMyCoupon();
    },
    getMyCoupon() {

      getMyCoupon(this.form)
        .then((response) => {
          if (response.status == this.$config.ajaxStatus) {
            let list = response.data;
            list.map(item=>{
              item.isOpen = false;
              item.text = '';
            })
            this.couponList = this.couponList.concat(list);
            if (
              this.couponList.length >=
              response.total
            ) {
              this.finished = true;
            }
          }else{
            this.finished = true;
          }
          this.loading = false;
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.form.accounPkId = this.$route.query.accountPkId;
    // this.getMyCoupon();
  },
};
</script>
<style lang="less">
.pi-my-coupon-third {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #efeff4;

  .coupon-third-list {
    flex: 1;
    padding: 0.2rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .coupon-third-ul{
    .coupon-third-item{
      background-color: #fff;
      border-radius: 0.2rem;
      padding: 0.2rem;
      margin-top: 0.2rem;
      .coupon-title{
        font-size: 0.34rem;
        color: #333;
        line-height: 0.48rem;
        position: relative;
        .coupon-type{
          font-size: 0.24rem;
          line-height: 0.33rem;
          display: inline-block;
          background: linear-gradient(180deg, #FEC446 0%, #F99130 100%);
          border-radius: 0.15rem;
          color: #fff;
          padding: 0 0.08rem;
          margin-right: 0.1rem;
        }
      }
      .info-text{
        margin-top: 0.12rem;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #666;
      }
      .explain{
        font-size: 0.24rem;
        line-height: 0.33rem;
        margin-top: 0.09rem;
        color: #666;
      }
      .explain-icon{
        float: right;
        img{
          width: 0.3rem;
          height: 0.3rem;
          transform: rotate(180deg);
        }
      }
      .explain-icon.open{
        img{
          transform: rotate(0deg);
        }
      }
    }
    .coupon-third-item:first-child{
      margin-top: 0;
    }
  }

}
</style>
